import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionOngoingPurchaseStandardDeselect } from "../../ongoing-purchase/actionOngoingPurchase";
import { TypeActionNotEnoughResource } from "../actionNotEnoughResource";
export var epicNotEnoughResourceCancel = function (action$) {
    return action$.pipe(ofType(TypeActionNotEnoughResource.Cancel), switchMap(function () {
        return from([
            actionModalClose(IdModal.NotEnoughResource),
            actionOngoingPurchaseStandardDeselect(),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/not-enough-resource/epics/epicNotEnoughResourceCancel.ts
// module id = 2024
// module chunks = 3